import * as React from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { apiFetch, refreshSession, setCsrfToken } from "../../api/client.js";
import { SessionExpiryGuard } from "./SessionExpiryGuard.jsx";

const h = React;
const k = { Fragment, jsx, jsxs };
export function AuthGate({ MainApplication }) {
    let [e, t] = (0, h.useState)(null), [n, r] = (0, h.useState)(!0), [i, a] = (0, h.useState)(!1);
    return (0, h.useEffect)(() => {
        refreshSession().then(({ data: e }) => {
            a(!!e.bootstrapRequired), e.authenticated && t(e.user)
        }).finally(() => r(!1))
    }, []), n ? (0, k.jsx)(`div`, {
        className: `login-shell`,
        children: (0, k.jsxs)(`div`, {
            className: `login-card`,
            children: [(0, k.jsx)(`b`, {
                children: `Microten`
            }), (0, k.jsx)(`p`, {
                children: `Comprobando sesión…`
            })]
        })
    }) : e ? (0, k.jsxs)(k.Fragment, { children: [(0, k.jsx)(MainApplication, {
        auth: e,
        onLogout: () => {
            setCsrfToken(``), t(null)
        }
    }), (0, k.jsx)(SessionExpiryGuard, { onLogout: () => { setCsrfToken(``), t(null) } })] }) : (0, k.jsx)(LoginScreen, {
        bootstrap: i,
        onLogin: e => {
            setCsrfToken(e.csrf), t(e), a(!1)
        }
    })
}

export function LoginScreen({
    bootstrap: e,
    onLogin: t
}) {
    let [n, r] = (0, h.useState)(``), [i, a] = (0, h.useState)(``), [o, s] = (0, h.useState)(``), [c, l] = (0, h.useState)(``), [u, d] = (0, h.useState)(``), [f, p] = (0, h.useState)(0), [, m] = (0, h.useState)(0), g = new URLSearchParams(location.search).get(`reset`) || ``, [_, v] = (0, h.useState)(g ? `reset` : `login`), [y, b] = (0, h.useState)(g), [x, ee] = (0, h.useState)(``), [S, C] = (0, h.useState)(``);
    (0, h.useEffect)(() => {
        if (!c) return;
        let e = setInterval(() => m(e => e + 1), 1e3);
        return () => clearInterval(e)
    }, [c]), (0, h.useEffect)(() => {
        g && apiFetch(`/api/auth.php?action=validate-reset`, {
            method: `POST`,
            headers: {
                "Content-Type": `application/json`
            },
            body: JSON.stringify({
                token: g
            })
        }).then(e => {
            e.ok || s(`El enlace no es válido o ha caducado.`)
        })
    }, []);
    let [w, te] = (0, h.useState)({
        adminName: ``,
        adminEmail: ``,
        adminPassword: ``,
        operatorName: ``,
        operatorEmail: ``,
        operatorPassword: ``
    }), ne = async () => {
        s(``);
        let e = await apiFetch(`/api/auth.php?action=login`, {
                method: `POST`,
                headers: {
                    "Content-Type": `application/json`
                },
                body: JSON.stringify({
                    email: n,
                    password: i
                })
            }),
            r = await e.json();
        if (!e.ok) {
            s(`Credenciales no válidas.`);
            return
        }
        if (r.requiresTwoFactor) {
            l(r.challengeToken), a(``), p(Date.now() + 6e4);
            return
        }
        t(r.user)
    }, re = async () => {
        s(``);
        let e = await apiFetch(`/api/auth.php?action=verify-2fa`, {
                method: `POST`,
                headers: {
                    "Content-Type": `application/json`
                },
                body: JSON.stringify({
                    challengeToken: c,
                    code: u
                })
            }),
            n = await e.json();
        if (!e.ok) {
            s(n.restartLogin ? `El código ya no es válido. Inicia sesión de nuevo.` : `Código no válido.`), n.restartLogin && (l(``), d(``));
            return
        }
        t(n.user)
    }, ie = async () => {
        s(``);
        let e = await apiFetch(`/api/auth.php?action=resend-2fa`, {
                method: `POST`,
                headers: {
                    "Content-Type": `application/json`
                },
                body: JSON.stringify({
                    challengeToken: c
                })
            }),
            t = await e.json();
        if (!e.ok) {
            s(t.retryAfter ? `Espera antes de solicitar otro código.` : `No se pudo reenviar el código.`);
            return
        }
        l(t.challengeToken), d(``), p(Date.now() + 6e4)
    }, ae = async () => {
        s(``), ee((await (await apiFetch(`/api/auth.php?action=request-reset`, {
            method: `POST`,
            headers: {
                "Content-Type": `application/json`
            },
            body: JSON.stringify({
                email: n
            })
        })).json().catch(() => ({}))).message || `Si la cuenta existe y está activa, recibirás un enlace de recuperación.`)
    }, oe = async () => {
        if (s(``), i.length < 12 || i !== S) {
            s(`La contraseña debe tener al menos 12 caracteres y ambas entradas deben coincidir.`);
            return
        }
        if (!(await apiFetch(`/api/auth.php?action=reset-password`, {
                method: `POST`,
                headers: {
                    "Content-Type": `application/json`
                },
                body: JSON.stringify({
                    token: y,
                    password: i
                })
            })).ok) {
            s(`El enlace no es válido o ha caducado.`);
            return
        }
        history.replaceState({}, ``, location.pathname), a(``), C(``), b(``), ee(`Contraseña actualizada. Inicia sesión de nuevo.`), v(`login`)
    }, se = async () => {
        if (s(``), !(await apiFetch(`/api/auth.php?action=bootstrap`, {
                method: `POST`,
                headers: {
                    "Content-Type": `application/json`
                },
                body: JSON.stringify({
                    admin: {
                        name: w.adminName,
                        email: w.adminEmail,
                        password: w.adminPassword
                    },
                    operator: {
                        name: w.operatorName,
                        email: w.operatorEmail,
                        password: w.operatorPassword
                    }
                })
            })).ok) {
            s(`Revisa los datos. Las contraseñas deben tener al menos 12 caracteres.`);
            return
        }
        r(w.adminEmail), a(``), location.reload()
    };
    return (0, k.jsx)(`div`, {
        className: `login-shell`,
        children: (0, k.jsxs)(`form`, {
            className: `login-card`,
            onSubmit: t => {
                t.preventDefault(), e ? se() : c ? re() : _ === `forgot` ? ae() : _ === `reset` ? oe() : ne()
            },
            children: [(0, k.jsx)(`p`, {
                className: `eyebrow`,
                children: `Portal operativo`
            }), (0, k.jsx)(`h1`, {
                children: `Microten`
            }), e ? (0, k.jsxs)(k.Fragment, {
                children: [(0, k.jsx)(`p`, {
                    children: `Configuración inicial segura`
                }), (0, k.jsx)(`input`, {
                    placeholder: `Nombre Administrador`,
                    value: w.adminName,
                    onChange: e => te({
                        ...w,
                        adminName: e.target.value
                    })
                }), (0, k.jsx)(`input`, {
                    type: `email`,
                    placeholder: `Email Administrador`,
                    value: w.adminEmail,
                    onChange: e => te({
                        ...w,
                        adminEmail: e.target.value
                    })
                }), (0, k.jsx)(`input`, {
                    type: `password`,
                    placeholder: `Contraseña Administrador`,
                    value: w.adminPassword,
                    onChange: e => te({
                        ...w,
                        adminPassword: e.target.value
                    })
                }), (0, k.jsx)(`input`, {
                    placeholder: `Nombre Operador`,
                    value: w.operatorName,
                    onChange: e => te({
                        ...w,
                        operatorName: e.target.value
                    })
                }), (0, k.jsx)(`input`, {
                    type: `email`,
                    placeholder: `Email Operador`,
                    value: w.operatorEmail,
                    onChange: e => te({
                        ...w,
                        operatorEmail: e.target.value
                    })
                }), (0, k.jsx)(`input`, {
                    type: `password`,
                    placeholder: `Contraseña Operador`,
                    value: w.operatorPassword,
                    onChange: e => te({
                        ...w,
                        operatorPassword: e.target.value
                    })
                }), (0, k.jsx)(`button`, {
                    className: `primary`,
                    type: `submit`,
                    children: `Crear usuarios de staging`
                })]
            }) : c ? (0, k.jsxs)(k.Fragment, {
                children: [(0, k.jsx)(`p`, {
                    children: `Introduce el código enviado a tu email. Caduca en 10 minutos.`
                }), (0, k.jsx)(`input`, {
                    inputMode: `numeric`,
                    autoComplete: `one-time-code`,
                    maxLength: 6,
                    placeholder: `Código de 6 dígitos`,
                    value: u,
                    onChange: e => d(e.target.value.replace(/\D/g, ``).slice(0, 6))
                }), (0, k.jsx)(`button`, {
                    className: `primary`,
                    type: `submit`,
                    disabled: u.length !== 6,
                    children: `Verificar código`
                }), (0, k.jsx)(`button`, {
                    type: `button`,
                    onClick: () => void ie(),
                    disabled: Date.now() < f,
                    children: `Reenviar código`
                }), (0, k.jsx)(`button`, {
                    type: `button`,
                    onClick: () => {
                        l(``), d(``), s(``)
                    },
                    children: `Volver al acceso`
                })]
            }) : _ === `forgot` ? (0, k.jsxs)(k.Fragment, {
                children: [(0, k.jsx)(`p`, {
                    children: `Recuperar contraseña`
                }), (0, k.jsx)(`input`, {
                    type: `email`,
                    autoComplete: `username`,
                    placeholder: `Usuario o email`,
                    value: n,
                    onChange: e => r(e.target.value)
                }), (0, k.jsx)(`button`, {
                    className: `primary`,
                    type: `submit`,
                    children: `Enviar enlace de recuperación`
                }), (0, k.jsx)(`button`, {
                    type: `button`,
                    onClick: () => {
                        v(`login`), s(``), ee(``)
                    },
                    children: `Volver al acceso`
                })]
            }) : _ === `reset` ? (0, k.jsxs)(k.Fragment, {
                children: [(0, k.jsx)(`p`, {
                    children: `Establece una nueva contraseña`
                }), (0, k.jsx)(`input`, {
                    type: `password`,
                    autoComplete: `new-password`,
                    placeholder: `Nueva contraseña`,
                    value: i,
                    onChange: e => a(e.target.value)
                }), (0, k.jsx)(`input`, {
                    type: `password`,
                    autoComplete: `new-password`,
                    placeholder: `Repetir nueva contraseña`,
                    value: S,
                    onChange: e => C(e.target.value)
                }), (0, k.jsx)(`button`, {
                    className: `primary`,
                    type: `submit`,
                    children: `Cambiar contraseña`
                }), (0, k.jsx)(`button`, {
                    type: `button`,
                    onClick: () => {
                        history.replaceState({}, ``, location.pathname), v(`login`), b(``), s(``)
                    },
                    children: `Volver al acceso`
                })]
            }) : (0, k.jsxs)(k.Fragment, {
                children: [(0, k.jsx)(`p`, {
                    children: `Inicia sesión para continuar`
                }), (0, k.jsx)(`input`, {
                    type: `email`,
                    autoComplete: `username`,
                    placeholder: `Usuario o email`,
                    value: n,
                    onChange: e => r(e.target.value)
                }), (0, k.jsx)(`input`, {
                    type: `password`,
                    autoComplete: `current-password`,
                    placeholder: `Contraseña`,
                    value: i,
                    onChange: e => a(e.target.value)
                }), (0, k.jsx)(`button`, {
                    className: `primary`,
                    type: `submit`,
                    children: `Entrar`
                }), (0, k.jsx)(`button`, {
                    type: `button`,
                    onClick: () => {
                        v(`forgot`), a(``), s(``), ee(``)
                    },
                    children: `He olvidado mi contraseña`
                })]
            }), x && (0, k.jsx)(`p`, {
                children: x
            }), o && (0, k.jsx)(`p`, {
                className: `login-error`,
                children: o
            })]
        })
    })
}


